import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { routes } from "./routes/routes";
import { useSelector } from "react-redux";
import { ThemeProvider, CssBaseline, GlobalStyles } from "@mui/material";
import type { RootState } from "./redux/store";
import { getTheme } from "./theme/theme";
import { useEffect } from "react";

function Shell() {
  const mode = useSelector((state: RootState) => state.theme.mode);
  const theme = getTheme(mode);
  const router = createBrowserRouter(routes);

<GlobalStyles
  styles={{
    body: {
      WebkitFontSmoothing: "antialiased",
      MozOsxFontSmoothing: "grayscale",
      textRendering: "optimizeLegibility",
    },
  }}
/>
useEffect(() => {
    document.body.setAttribute("data-theme", mode);
  }, [mode]);
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <RouterProvider router={router} />
      <Toaster position="top-right" />
    </ThemeProvider>
  );
}

export default Shell;
